<template>
  <v-card class="mb-4 app">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-container>
      <v-row>
        <v-col cols="4">
          <Container
            @click="handleDragStart('arrayPesquisa', $event)"
            :get-child-payload="getChildPayload"
            :drop-placeholder="{ class: 'placeholder' }"
          >
            <v-select
              class="mt-5"
              v-model="pesquisaSelecionada"
              :items="arrayPesquisas"
              :label="dragname"
              return-object
              outlined
              dense
            />
          </Container>
        </v-col>
        <v-col cols="4">
          <Container
            @click="handleDragStart('arrayPesquisas', $event)"
            :get-child-payload="getChildPayload"
            :drop-placeholder="{ class: 'placeholder' }"
          >
            <v-select class="mt-5" v-model="tagSelecionada" :items="tagsPesquisa" label="TAG" outlined dense />
          </Container>
        </v-col>
        <v-col class="text-right" cols="4">
          <v-btn class="mt-5" color="bluePcm" dark @click="insere()">Selecionar</v-btn>
          <v-spacer />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card outlined>
            <v-list dense color="background">
              <div>
                <v-subheader>{{ dragname.toUpperCase() }}</v-subheader>
                <v-list-item-group v-model="item">
                  <div>
                    <Container
                      :group-name="dragname"
                      @drag-start="handleDragStart('ValoresSelecionadosDrag', $event, ValoresSelecionadosDrag)"
                      @drop="handleDrop('ValoresSelecionadosDrag', $event)"
                      :get-child-payload="getChildPayload"
                      :drop-placeholder="{ class: 'placeholder' }"
                    >
                      <Draggable v-for="(valor, key) in ValoresSelecionadosDrag" :key="key">
                        <Card>
                          <v-list-item>
                            <v-list-item-content>
                              <div class="line-item-table">
                                <div class="mr-1">{{ key + 1 }} -</div>
                                <strong class="mr-1">PESQUISA: </strong>
                                <div class="mr-1">{{ valor.descricaoPesquisa }},</div>
                                <strong class="mr-1">TAG: </strong>{{ valor.descricaoTag }}
                              </div>
                            </v-list-item-content>
                            <v-list-item-icon>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon color="darkRed" @click="remove(key)" v-bind="attrs" v-on="on">
                                    mdi-close-circle
                                  </v-icon>
                                </template>
                                <span>Remover</span>
                              </v-tooltip>
                            </v-list-item-icon>
                          </v-list-item>
                          <v-divider class="mx-2" />
                        </Card>
                      </Draggable>
                    </Container>
                  </div>
                </v-list-item-group>
              </div>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { Container, Draggable } from 'vue-smooth-dnd'
import { mapActions, mapGetters } from 'vuex'

import rotasStore from '../../../../store'
import { registerVuexModule } from '@/utils/vuexUtils'

import Card from '@/componentes/Card'
import Snackbar from '@/componentes/Snackbar'

export default {
  name: 'DraggAndDrop',
  props: {
    dragname: String,
    arrayPesquisa: Array,
    opcoesSelecionadas: Array,
  },
  components: { Container, Draggable, Card, Snackbar },

  data: () => ({
    item: -1,
    pesquisaSelecionada: '',
    arrayPesquisas: [],
    tagSelecionada: '',
    ValoresSelecionadosDrag: [],
    snackbar: false,
    text: '',
    tagsPesquisa: [],
  }),

  computed: {
    ...mapGetters('draggAndDroppAvaliacaoAtendimentoModulePABXStore', ['getTags']),
  },

  async created() {
    registerVuexModule(this.$store, 'draggAndDroppAvaliacaoAtendimentoModulePABXStore', rotasStore)

    await this.listarTags()
    this.tagsPesquisa = this.getTags.map(tag => ({ text: tag.description, value: tag._id }))
  },

  methods: {
    ...mapActions('draggAndDroppAvaliacaoAtendimentoModulePABXStore', ['listarTags']),

    handleDragStart(lane, dragResult, value) {
      const { payload, isSource } = dragResult
      if (isSource) {
        this.draggingCard = {
          lane,
          index: payload.index,
          cardData: {
            value: value[payload.index],
          },
        }
      }
    },
    handleDrop(lane, dropResult) {
      const { removedIndex, addedIndex } = dropResult
      if (lane === this.draggingCard.lane && removedIndex === addedIndex) {
        return
      }

      if (removedIndex !== null) {
        this.ValoresSelecionadosDrag.splice(removedIndex, 1)
      }

      if (addedIndex !== null) {
        this.ValoresSelecionadosDrag.splice(addedIndex, 0, this.draggingCard.cardData.value)
      }
    },
    insere() {
      if (!this.pesquisaSelecionada || !this.tagSelecionada) {
        this.text = 'Necessário escolher uma avaliação e uma TAG.'
        this.snackbar = true
        return
      }

      const tagSelecionaNow = this.getTags.find(tag => tag._id === this.tagSelecionada)

      this.ValoresSelecionadosDrag.push({
        pesquisa: this.pesquisaSelecionada.value,
        descricaoPesquisa: this.pesquisaSelecionada.text,
        tag: this.tagSelecionada,
        descricaoTag: tagSelecionaNow.description,
      })

      this.arrayPesquisas = this.arrayPesquisas.filter(element => element.value !== this.pesquisaSelecionada.value)

      this.pesquisaSelecionada = ''
      this.tagSelecionada = ''
    },
    remove(key) {
      this.arrayPesquisas.push({
        text: this.ValoresSelecionadosDrag[key].descricaoPesquisa,
        value: this.ValoresSelecionadosDrag[key].pesquisa,
      })
      this.ValoresSelecionadosDrag.splice(key, 1)
    },

    getChildPayload(index) {
      return {
        index,
      }
    },
  },
  watch: {
    arrayPesquisa: {
      deep: true,
      handler() {
        this.arrayPesquisas = [...this.arrayPesquisa]
      },
    },

    ValoresSelecionadosDrag(dragnovo) {
      this.$emit('dragUpdate', dragnovo)
    },

    opcoesSelecionadas: {
      deep: true,
      async handler(novo) {
        if (this.getTags.length === 0) {
          await this.listarTags()
        }

        this.ValoresSelecionadosDrag = novo.map(opcao => {
          const descricaoPesquisa = this.arrayPesquisa.find(pesquisa => pesquisa.value === opcao.pesquisa)
          const descricaoTag = this.getTags.find(tag => tag._id === opcao.tag)

          const returnTag = {
            pesquisa: opcao.pesquisa,
            tag: opcao.tag,
            descricaoPesquisa: descricaoPesquisa.text,
            descricaoTag: descricaoTag.description,
          }
          return returnTag
        })

        this.ValoresSelecionadosDrag.forEach(valorSelecionado => {
          this.arrayPesquisas = this.arrayPesquisas.filter(pesquisa => pesquisa.value !== valorSelecionado.pesquisa)
        })
      },
    },
  },
}
</script>

<style scoped>
.line-item-table {
  display: flex;
  align-items: center;
}

.lane {
  min-width: 50px;
  min-height: 50px;
  margin: 0 0.8rem;
  padding: 0 0.7rem;
}

.placeholder {
  background: rgba(33, 33, 33, 0.08);
  border-radius: 0.4rem;
  transform: scaleY(0.65);
  transform-origin: 0% 0%;
}

.app {
  background-color: var(--v-background-base);
}
</style>
